import React from 'react'
import Section from '../../../../components/section'
import Text from '../../../../components/text'
import Input from '../../../../components/input'
import Button from '../../../../components/button'
import {useFormik} from "formik";
import * as Yup from "yup";
import Flex from '../../../../components/flex'
import Select from '../../../../components/input/select'
import useLogin from '../../../authentication/login/hooks/login.hook'
import Checkbox from "../../../../components/checkbox";
import {Link} from "react-router-dom";

const AddVehicleInformationView = props => {
    const {
        alphanumeric
    } = useLogin();
    const {
        onSubmitAddVehicle,
        vehicleMakesList
    } = props;
    const formik = useFormik({
        initialValues: {
            make: '',
            model: '',
            color: '',
            licensePlateState: '',
            licensePlateNumber: '',
            isElectricVehicle: false,
        },
        validationSchema: Yup.object({
            make: Yup.string().required('Please enter a valid make'),
            model: Yup.string().required('Please enter a valid model'),
            color: Yup.string().required('Please enter a valid color'),
            licensePlateState: Yup.string().required('Please enter a valid license plate state'),
            licensePlateNumber: Yup.string().matches(alphanumeric, 'Please enter a alphanumeric require').max(10, 'License plate number can not be more than 10 characters').required('Pease enter a valid license plate number'),
        }),
        onSubmit: (values, actions) => {
            const body = {
                make: values.make,
                model:values.model,
                color:values.color,
                license_state:values.licensePlateState,
                license_plate_number:values.licensePlateNumber,
                is_electric: values.isElectricVehicle ? 1 : 0
            }
            onSubmitAddVehicle(body, actions)
        }
    });

    const optionLicensePlateState = [
        {
            value: 'AL',
            label:  "Alabama"
        },

        {
            value: "AK",
            label:  "Alaska"
        },
        {
            value: "AS",
            label:  "American Samoa"
        },
        {
            value: "AZ",
            label:  "Arizona"
        },
        {
            value: "AR",
            label:  "Arkansas"
        },
        {
            value: "CA",
            label:  "California"
        },
        {
            value: "CO",
            label:  "Colorado"
        },
        {
            value: "CT",
            label:  "Connecticut"
        },
        {
            value: "DE",
            label:  "Delaware"
        },
        {
            value: "DC",
            label:  "District of Columbia"
        },
        {
            value: "FM",
            label:  "Federated States of Micronesia"
        },
        {
            value: "FL",
            label:  "Florida"
        },
        {
            value: "GA",
            label:  "Georgia"
        },
        {
            value: "GU",
            label:  "Guam"
        },
        {
            value: "HI",
            label:  "Hawaii"
        },
        {
            value: "ID",
            label:  "Idaho"
        },
        {
            value: "IL",
            label:  "Illinois"
        },
        {
            value: "IN",
            label:  "Indiana"
        },
        {
            value: "IA",
            label:  "Iowa"
        },
        {
            value: "KS",
            label:  "Kansas"
        },
        {
            value: "KY",
            label:  "Kentucky"
        },
        {
            value: "LA",
            label:  "Louisiana"
        },
        {
            value: "ME",
            label:  "Maine"
        },
        {
            value: "MH",
            label:  "Marshall Islands"
        },
        {
            value: "MD",
            label:  "Maryland"
        },
        {
            value: "MA",
            label:  "Massachusetts"
        },
        {
            value: "MI",
            label:  "Michigan"
        },
        {
            value: "MN",
            label:  "Minnesota"
        },
        {
            value: "MS",
            label:  "Mississippi"
        },
        {
            value: "MO",
            label:  "Missouri"
        },
        {
            value: "MT",
            label:  "Montana"
        },
        {
            value: "NE",
            label:  "Nebraska"
        },
        {
            value: "NV",
            label:  "Nevada"
        },
        {
            value: "NH",
            label:  "New Hampshire"
        },
        {
            value: "NJ",
            label:  "New Jersey"
        },
        {
            value: "NM",
            label:  "New Mexico"
        },
        {
            value: "NY",
            label:  "New York"
        },
        {
            value: "NC",
            label:  "North Carolina"
        },
        {
            value: "ND",
            label:  "North Dakota"
        },
        {
            value: "MP",
            label:  "Northern Mariana Islands"
        },
        {
            value: "OH",
            label:  "Ohio"
        },
        {
            value: "OK",
            label:  "Oklahoma"
        },
        {
            value: "OR",
            label:  "Oregon"
        },
        {
            value: "PW",
            label:  "Palau"
        },
        {
            value: "PA",
            label:  "Pennsylvania"
        },
        {
            value: "PR",
            label:  "Puerto Rico"
        },
        {
            value: "RI",
            label:  "Rhode Island"
        },
        {
            value: "SC",
            label:  "South Carolina"
        },
        {
            value: "SD",
            label:  "South Dakota"
        },
        {
            value: "TN",
            label:  "Tennessee"
        },
        {
            value: "TX",
            label:  "Texas"
        },
        {
            value: "UT",
            label:  "Utah"
        },
        {
            value: "VT",
            label:  "Vermont"
        },
        {
            value: "VI",
            label:  "Virgin Islands"
        },
        {
            value: "VA",
            label:  "Virginia"
        },
        {
            value: "WA",
            label:  "Washington"
        },
        {
            value: "WV",
            label:  "West Virginia"
        },
        {
            value: "WI",
            label:  "Wisconsin"
        },
        {
            value: "WY",
            label:  "Wyoming"
        },


        {
            value: 'Alberta',
            label: 'Alberta'
        },
        {
            value: 'British Columbia',
            label: 'British Columbia'
        },
        {
            value: 'Manitoba',
            label: 'Manitoba'
        },
        {
            value: 'New Brunswick',
            label: 'New Brunswick'
        },
        {
            value: 'Newfoundland and Labrador',
            label: 'Newfoundland and Labrador'
        },
        {
            value: 'Nova Scotia',
            label: 'Nova Scotia'
        },
        {
            value: 'Ontario',
            label: 'Ontario'
        },
        {
            value: 'Prince Edward Island',
            label: 'Prince Edward Island'
        },
        {
            value: 'Quebec',
            label: 'Quebec'
        },
        {
            value: 'Saskatchewan',
            label: 'Saskatchewan'
        },
        {
            value: 'Northwest Territories',
            label: 'Northwest Territories'
        },
        {
            value: 'Nunavut',
            label: 'Nunavut'
        },
        {
            value: 'Yukon',
            label: 'Yukon'
        },


    ]
    return (
        <>
            <Section>
                <div className="row">
                    <div className="col-12 col-md-12">
                        <Text type="H1" text="Add/Edit Vehicle Information" />
                        <form onSubmit={formik.handleSubmit}>
                            <div className="row">
                                <div className="col-12 col-md-6">
                                    <div className="formBox">
                                        <Select
                                            label="Make"
                                            name="make"
                                            value={formik.values.make}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            placeholder="Select Make"
                                            mandatory
                                            options={vehicleMakesList}
                                            errormessage={formik.touched.make && formik.errors.make ? (
                                                formik.errors.make
                                            ) : null}
                                        />
                                        
                                    </div>
                                </div>
                                <div className="col-12 col-md-6">
                                    <div className="formBox">
                                        <Input
                                            label="Model"
                                            type="text"
                                            name="model"
                                            placeholder="Your Vehicle Model"
                                            value={formik.values.model}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            mandatory
                                            errormessage={formik.touched.model && formik.errors.model ? (
                                                formik.errors.model
                                            ) : null}
                                        />
                                    </div>
                                </div>
                                <div className="col-12 col-md-6">
                                    <div className="formBox">
                                        <Input
                                            label="Color"
                                            type="text"
                                            name="color"
                                            placeholder="Your Color"
                                            autoFocus={true}
                                            value={formik.values.color}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            mandatory
                                            errormessage={formik.touched.color && formik.errors.color ? (
                                                formik.errors.color
                                            ) : null}
                                        />
                                    </div>
                                </div>
                                <div className="col-12 col-md-6">
                                    <div className="formBox">
                                        <Select
                                            label="License Plate State"
                                            name="licensePlateState"
                                            value={formik.values.licensePlateState}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            placeholder="Select License Plate State"
                                            mandatory
                                            options={optionLicensePlateState}
                                            errormessage={formik.touched.licensePlateState && formik.errors.licensePlateState ? (
                                                formik.errors.licensePlateState
                                            ) : null}
                                        />
                                    </div>
                                </div>
                                <div className="col-12 col-md-6">
                                    <div className="formBox">
                                        <Input
                                            label="License Plate Number"
                                            type="text"
                                            name="licensePlateNumber"
                                            placeholder="Your License plate Number"
                                            autoFocus={true}
                                            value={formik.values.licensePlateNumber}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            mandatory
                                            errormessage={formik.touched.licensePlateNumber && formik.errors.licensePlateNumber ? (
                                                formik.errors.licensePlateNumber
                                            ) : null}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 col-md-12">
                                    <div className="row">

                                    <div className="col-12 col-md-6">
                                        <div className="formBox">
                                            <Checkbox
                                                name="isElectricVehicle"
                                                value={formik.values.isElectricVehicle}
                                                label={<>Is this an Electric Vehicle (EV)</>}
                                                id="isElectricVehicle"
                                                isChecked={formik.values.isElectricVehicle}
                                                onChange={formik.handleChange}
                                                errormessage={formik.touched.isElectricVehicle && formik.errors.isElectricVehicle ? (
                                                    formik.errors.isElectricVehicle
                                                ) : null}
                                                mandatory
                                            />

                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                            
                            {/* <Flex justifyContent="end" className="mb-48">
                                <Button
                                    link
                                    text="Back to login"
                                    onClick={goBackToLogin}
                                    type="button"
                                />
                            </Flex> */}
                            <Flex justifyContent="end" className="mb-48">
                                <Button
                                    type="submit"
                                    text="Submit"
                                    large
                                    isSubmitting={formik.isSubmitting}
                                    disabled={formik.isSubmitting}
                                />
                            </Flex>
                        </form>
                    </div>
                </div>
            </Section>
        </>
    )
}

export default AddVehicleInformationView